import type { MaybeComputedElementRef } from "@vueuse/core";

export const useElementVisibilityOnce = (element: MaybeComputedElementRef) => {
  const isVisible = useElementVisibility(element);

  const isVisibleOnce = ref(false);

  watch(
    isVisible,
    (newValue) => {
      if (newValue) {
        isVisibleOnce.value = true;
      }
    },
    { immediate: true }
  );

  return isVisibleOnce;
};
